//import action types
import * as types from "../actions/types"

const initialState = {
  currentUser: [],
  error: []
};

const userLoginReducer = (variable = initialState, action) => {
    const { type, payload } = action;
    switch(action.type){
      case types.login_success:
        return {
          ...variable,
          currentUser: action.payload
        };
      case types.login_failure:
        return {
          ...variable,
          error: action.payload
        };
      default:
        return variable;
    }
  };


export default userLoginReducer;
